import VirtualJoyStick from './input/virtualjoystick/VirtualJoyStick.js';
export default VirtualJoyStick;